const config = window.RUNTIME_CONFIG || {};

export const BACKEND_URL_RECOG   = config.BACKEND_URL_RECOG;
export const BACKEND_URL_DICT    = config.BACKEND_URL_DICT;
export const BACKEND_URL_DUBBING = config.BACKEND_URL_DUBBING;
